import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Star, Clock, MapPin } from 'lucide-react';
import ResponsiveImage from '../../components/common/ResponsiveImage';
const IntroSection: React.FC = () => {
  return <section className="py-24 bg-[#F5F5DC] relative overflow-hidden" aria-labelledby="intro-heading" role="region">
      <div className="absolute inset-0 paper-texture opacity-50" aria-hidden="true"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-32 h-32 bg-[#1E7B63]/5 rounded-full animate-float"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-[#8B4513]/5 rounded-full animate-float-delayed"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-in">
            <div className="inline-flex items-center px-4 py-1.5 bg-[#1E7B63]/10 rounded-full text-[#1E7B63] text-sm font-medium mb-6 group hover:bg-[#1E7B63]/20 transition-colors duration-300" role="status" aria-label="Tour category">
              <Star className="w-4 h-4 mr-2" aria-hidden="true" />
              <span>The Only Cat-Themed Historical Walking Tours in NYC - Tales from Whiskers Past</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold mb-8 text-[#8B4513] leading-tight" id="intro-heading">
              Time-Travel Through NYC's Feline History: Where Cats Made Their Mark!
            </h2>
            
            <p className="text-lg mb-10 text-[#8B4513] leading-relaxed">In just two hours, you'll hear the furr-bulous tales of cats who left paw prints on NYC's history—like the brave feline mascot who kept a 19th-century firehouse mouse-free! Curated by expert storyteller and cat historian Peggy Gavan and led by our fantastic guides, our walking tours offer a unique lens on NYC's rich history, told through the lives of its feline residents.</p>

            {/* Added tour note about cat spotting */}
            <div className="mb-10 p-4 bg-[#1E7B63]/10 rounded-lg text-[#1E7B63] text-sm">
              <p><strong>Tour Note:</strong> Our tours focus on historical stories and not cat-spotting safaris (though if we see a feline friend along the way, we'll consider it a purr-fect bonus!)</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/tours" className="group bg-[#8B4513] text-white hover:text-white inline-flex items-center gap-2 px-8 py-3 shadow-md rounded-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg min-w-[200px] min-h-[48px] justify-center" aria-label="Explore our tour offerings" role="button">
                <Compass className="w-5 h-5 transition-transform duration-300 group-hover:rotate-12" aria-hidden="true" />
                <span className="font-medium">Explore Our Tours</span>
              </Link>
            </div>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4">
              <div className="flex items-center gap-2 text-[#3E2723]">
                <Clock className="w-5 h-5 text-[#8B4513]" />
                <span className="text-sm">90-min tours</span>
              </div>
              <div className="flex items-center gap-2 text-[#3E2723]">
                <MapPin className="w-5 h-5 text-[#8B4513]" />
                <span className="text-sm">3 locations</span>
              </div>
              <div className="flex items-center gap-2 text-[#3E2723]">
                <Star className="w-5 h-5 text-[#8B4513]" />
                <span className="text-sm">4.9/5 rating</span>
              </div>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="relative animate-fade-in animation-delay-200">
              <div className="absolute -top-5 -right-5 w-16 h-16 rounded-full bg-[#1E7B63]/20 animate-pulse" aria-hidden="true"></div>
              <div className="absolute -bottom-4 -left-4 w-12 h-12 rounded-full bg-[#8B4513]/10 animate-pulse-delayed" aria-hidden="true"></div>
              
              {/* Tour images showcase - showing only 1 image now */}
              <div>
                <div className="group relative overflow-hidden rounded-xl mb-4">
                  <ResponsiveImage src="https://catsabouttowntours.com/lovable-uploads/3a41ff29-c567-41dc-b249-03edc4cf969b.png" alt="Tour guide explaining cat history to group" className="rounded-xl shadow-premium relative z-10 transition-all duration-500 object-cover h-[400px] w-full group-hover:scale-105" loading="lazy" sizes="(max-width: 768px) 100vw, 50vw" width={640} height={480} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" aria-hidden="true"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default IntroSection;